import { combineReducers } from 'redux'

import developmentReducer from './developmentReducer'
import blogReducer from './blogReducer'

export default combineReducers({
  developmentReducer,
  blogReducer
});
